import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import TeilsicherheitsbeiwertStahltragglied from "../../../TeilsicherheitsbeiwertStahltragglied";
import Aussendurchmesser from "../../general/Aussendurchmesser";
import Biegesteifigkeit from "../../general/Biegesteifigkeit";
import CharakteristischeFestigkeit from "../../general/CharakteristischeFestigkeit";
import Dehnsteifigkeit from "../../general/Dehnsteifigkeit";
import EModul from "../../general/EModul";
import Imperfektionsbeiwert from "../../general/Imperfektionsbeiwert";
import Innendurchmesser from "../../general/Innendurchmesser";
import QuerschnittStahltragglied from "../../general/QuerschnittStahltragglied";
import Traegheitsmoment from "../../general/Traegheitsmoment";

function ParameterTragglied({
  expand,
  querschnitt,
  innendurchmesser,
  aussendurchmesser,
  dehnsteifigkeit,
  e_modul,
  traegheitsmoment,
  biegesteifigkeit,
  charakteristischeFestigkeit,
}) {
  const { t } = useTranslation("translation", {
    keyPrefix: "inner.buckling.dinEN1993.parameterTragglied",
  });
  const hide = `${expand ? "box" : "d-sm-none"} `;

  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("headline")}</h1>
        </div>
      </div>
      <div className="row">
        <div className={`${hide} col-md-12`} style={{ paddingBottom: 15 }}>
          <p>{t("headlineSub")}</p>
        </div>
      </div>
      <div className="row">
        {/* Querschnitt Stahltragglied */}
        <AnimatedCol expand={expand}>
          <QuerschnittStahltragglied querschnitt={querschnitt} />
        </AnimatedCol>

        {/* Innendurchmesser */}
        <AnimatedCol expand={expand}>
          <Innendurchmesser innendurchmesser={innendurchmesser} />
        </AnimatedCol>

        {/* Außendurchmesser */}
        <AnimatedCol expand={expand}>
          <Aussendurchmesser aussendurchmesser={aussendurchmesser} />
        </AnimatedCol>

        {/* Dehnsteifigkeit */}
        <AnimatedCol expand={expand}>
          <Dehnsteifigkeit dehnsteifigkeit={dehnsteifigkeit} />
        </AnimatedCol>

        {/* E-Modul */}
        <AnimatedCol expand={expand}>
          <EModul e_modul={e_modul} />
        </AnimatedCol>

        {/* Trägheitsmoment */}
        <AnimatedCol expand={expand}>
          <Traegheitsmoment traegheitsmoment={traegheitsmoment} />
        </AnimatedCol>

        {/* Biegesteifigkeit */}
        <AnimatedCol expand={expand}>
          <Biegesteifigkeit biegesteifigkeit={biegesteifigkeit} />
        </AnimatedCol>

        {/* Imperfektionsbeiwert */}
        <AnimatedCol expand={expand}>
          <Imperfektionsbeiwert />
        </AnimatedCol>

        {/* charakteristische Festigkeit */}
        <AnimatedCol expand={expand}>
          <CharakteristischeFestigkeit charakteristischeFestigkeit={charakteristischeFestigkeit} />

          {/* charakteristische Festigkeit */}
          <AnimatedCol expand={expand}>
            <TeilsicherheitsbeiwertStahltragglied />
          </AnimatedCol>
        </AnimatedCol>
      </div>
    </div>
  );
}

export default ParameterTragglied;
